'use client';

import Image from 'next/image';
import { Modal } from 'react-bootstrap';
import { useTranslations } from 'next-intl';

import styles from './customize-remove-confirmation.module.scss';

interface RemoveCustomizeProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RemoveCustomizeConfirmation({ 
  show, 
  onClose, 
  onConfirm
}: RemoveCustomizeProps) {
  const t = useTranslations();

  return (
    <Modal 
      show={show} 
      onHide={onClose}
      backdrop="static"
      keyboard={false} 
      centered
      className={styles.bottomSheet}
    >
      <Modal.Body className={styles.content}>
          <>
            <div className={styles.successContent}>
              <div className={styles.imageWrapper}>
                <Image
                  src="/assets/images/order-canceled.png"
                  alt="Order Canceled"
                  width={173}
                  height={149}
                  priority
                />
              </div>
              <div className={styles.message}>
                <h2>{t('removeCustomizeConfirmation.Title')}</h2>
                <p>{t('removeCustomizeConfirmation.Massage')}</p>
              </div>
              <div className={styles.buttonGrop}>
                <button
                    id="confirm-keep-item-button"
                    className={`${styles.button} ${styles.secondary}`}
                    onClick={onClose}
                >
                 {t('removeCustomizeConfirmation.ConfirmTxt')}
                </button>
                <button
                    id="confirm-remove-item-button"
                    className={`${styles.button} ${styles.primary}`}
                    onClick={onConfirm}
                >
                {t('removeCustomizeConfirmation.cancelTxt')}
                </button>
              </div>
            </div>
          </>
      </Modal.Body>
    </Modal>
  );
}
